import { useEffect, useState } from 'react';
import { defineMessages } from 'react-intl';

import { Form } from '#src/components/noCardRoute/Form/index.tsx';

import { useAcceptSo5NoCardLineup } from './useAcceptSo5NoCardLineup.ts';

const messages = defineMessages({
  title: {
    defaultMessage:
      'We’ll send you an email for you to select the competition your team can be entered into.',
  },
});

type Props = {
  so5LineupId: string;
};

export const Accept = ({ so5LineupId }: Props) => {
  const [acceptLineup, loading] = useAcceptSo5NoCardLineup();

  const [mutationResult, setMutationResult] =
    useState<Awaited<ReturnType<typeof acceptLineup>>>();

  useEffect(() => {
    acceptLineup({
      so5NoCardLineupId: `So5NoCardLineup:${so5LineupId}`,
    }).then(setMutationResult);
  }, [so5LineupId, acceptLineup]);

  return <Form title={messages.title} loading={loading} {...mutationResult} />;
};
